import React, { useState, useEffect, useCallback } from 'react';
import '../styles/EasterEggs.css';

const memes = [
  { url: 'https://i.imgur.com/5e5Iein.png', caption: 'When the code works on first try' },
  { url: 'https://i.imgur.com/oBGMVhS.png', caption: 'Me explaining my spaghetti code' },
  { url: 'https://i.imgur.com/7QpSPmJ.png', caption: 'It works on my machine 🤷' },
  { url: 'https://i.imgur.com/wN6iyDs.png', caption: 'When you fix one bug and create three more' },
  { url: 'https://i.imgur.com/QMpGgpQ.png', caption: 'git commit -m "final final FINAL fix"' },
];

function Confetti() {
  const colors = ['#00E5FF', '#7C3AED', '#10B981', '#F59E0B', '#EF4444', '#fff'];
  return (
    <div className="confetti-container" aria-hidden="true">
      {Array.from({ length: 80 }).map((_, i) => (
        <div
          key={i}
          className="confetti-piece"
          style={{
            left: `${Math.random() * 100}%`,
            background: colors[Math.floor(Math.random() * colors.length)],
            animationDelay: `${Math.random() * 1.5}s`,
            animationDuration: `${2 + Math.random() * 2}s`,
            width: `${6 + Math.random() * 8}px`,
            height: `${6 + Math.random() * 8}px`,
            borderRadius: Math.random() > 0.5 ? '50%' : '2px',
          }}
        />
      ))}
    </div>
  );
}

function EasterEggs() {
  const [memeVisible, setMemeVisible] = useState(false);
  const [currentMeme, setCurrentMeme] = useState(memes[0]);
  const [confettiVisible, setConfettiVisible] = useState(false);
  const [hireAlert, setHireAlert] = useState(false);
  const [, setTypedKeys] = useState('');

  const showRandomMeme = useCallback(() => {
    const random = memes[Math.floor(Math.random() * memes.length)];
    setCurrentMeme(random);
    setMemeVisible(true);
  }, []);

  // Easter egg: type 'hireme' anywhere
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!e.key || typeof e.key !== 'string') return;
      setTypedKeys(prev => {
        const next = (prev + e.key.toLowerCase()).slice(-6);
        if (next === 'hireme') {
          setHireAlert(true);
          return '';
        }
        return next;
      });
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  // Easter egg: confetti via custom event (triggered from Navbar)
  useEffect(() => {
    const handleConfetti = () => {
      setConfettiVisible(true);
      setTimeout(() => setConfettiVisible(false), 4000);
    };
    window.addEventListener('triggerConfetti', handleConfetti);
    return () => window.removeEventListener('triggerConfetti', handleConfetti);
  }, []);

  // Expose meme trigger globally (used by About.js triple click)
  useEffect(() => {
    window.__showDevMeme = showRandomMeme;
    return () => { delete window.__showDevMeme; };
  }, [showRandomMeme]);

  return (
    <>
      {confettiVisible && <Confetti />}

      {/* Meme Popup */}
      {memeVisible && (
        <div className="easter-overlay" onClick={() => setMemeVisible(false)}>
          <div className="meme-popup" onClick={e => e.stopPropagation()}>
            <button className="easter-close" onClick={() => setMemeVisible(false)}>✕</button>
            <div className="meme-badge">🥚 Easter Egg Found!</div>
            <img src={currentMeme.url} alt="dev meme" className="meme-img" />
            <p className="meme-caption">{currentMeme.caption}</p>
            <button className="meme-next-btn" onClick={showRandomMeme}>Another one 🎲</button>
          </div>
        </div>
      )}

      {/* Hire Me Alert */}
      {hireAlert && (
        <div className="easter-overlay" onClick={() => setHireAlert(false)}>
          <div className="hire-popup" onClick={e => e.stopPropagation()}>
            <button className="easter-close" onClick={() => setHireAlert(false)}>✕</button>
            <div className="hire-emoji">👀</div>
            <h2 className="hire-title">Oh, you typed <span>"hire me"</span>?</h2>
            <p className="hire-desc">
              Bold move. I respect it.<br />
              Let's skip the formalities — just hit the Contact section and let's talk. 🚀
            </p>
            <button
              className="hire-cta"
              onClick={() => {
                setHireAlert(false);
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Take me to Contact ↓
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default EasterEggs;